// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Enseignants.css — Module Enseignants
   Suit exactement le même pattern que AccueilDashboard
   ============================================================ */

.ens-page {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background: #f8fafc;
}

/* ── Topbar (même règles qu'accueil-topbar) ── */
.ens-topbar {
    color: white;
    padding: 12px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    position: sticky;
    top: 0;
    z-index: 50;
    /* background défini via inline style (couleur module) */
}

.ens-topbar-left {
    display: flex;
    align-items: center;
    gap: 14px;
}

/* Icône dans un carré arrondi légèrement plus clair — même règle que sidebar */
.ens-topbar-icon {
    font-size: 1.4rem;
    background: rgba(255, 255, 255, 0.2);
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    flex-shrink: 0;
}

.ens-topbar-title {
    font-size: 1.05rem;
    font-weight: 700;
}

.ens-topbar-sub {
    font-size: 0.8rem;
    opacity: 0.75;
    margin-top: 2px;
}

.ens-btn-add {
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.4);
    color: white;
    border-radius: 8px;
    padding: 8px 16px;
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: background 0.15s;
}
.ens-btn-add:hover {
    background: rgba(255, 255, 255, 0.3);
}

/* ── Corps de la page ── */
.ens-content {
    padding: 24px;
    flex: 1 1;
}

/* ── Stat cards ── */
.ens-stats {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 20px;
}

.ens-stat-card {
    background: white;
    border-radius: 10px;
    border-left: 4px solid #94a3b8;
    padding: 12px 18px;
    min-width: 130px;
    cursor: pointer;
    box-shadow: 0 1px 4px rgba(0,0,0,0.06);
    transition: box-shadow 0.15s, transform 0.15s;
}
.ens-stat-card:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    transform: translateY(-1px);
}

.ens-stat-count {
    font-size: 1.6rem;
    font-weight: 800;
    line-height: 1;
}
.ens-stat-label {
    font-size: 0.75rem;
    color: #64748b;
    margin-top: 4px;
}

/* ── Toolbar filtres ── */
.ens-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
    flex-wrap: wrap;
}

.ens-search-wrap {
    position: relative;
    flex: 1 1;
    min-width: 220px;
}
.ens-search-wrap > i {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    font-size: 0.85rem;
}
.ens-search {
    width: 100%;
    padding: 8px 36px 8px 34px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 0.875rem;
    outline: none;
    background: white;
    transition: border-color 0.15s;
    box-sizing: border-box;
}
.ens-search:focus {
    border-color: #a78bfa;
    box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.1);
}
.ens-search-clear {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: #94a3b8;
    cursor: pointer;
    padding: 2px 4px;
}

.ens-filter-select {
    padding: 8px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 0.875rem;
    background: white;
    color: #374151;
    outline: none;
    cursor: pointer;
}
.ens-filter-select:focus {
    border-color: #a78bfa;
}

/* ── Tableau ── */
.ens-table-wrap {
    background: white;
    border-radius: 12px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.06);
    overflow: hidden;
}

.ens-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.875rem;
}

.ens-table thead th {
    background: #f8fafc;
    padding: 10px 16px;
    text-align: left;
    font-size: 0.75rem;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border-bottom: 1px solid #e2e8f0;
}

.ens-table tbody tr {
    border-bottom: 1px solid #f1f5f9;
    transition: background 0.1s;
}
.ens-table tbody tr:last-child { border-bottom: none; }
.ens-table tbody tr:hover { background: #f8fafc; }
.ens-row-inactive { opacity: 0.55; }

.ens-table td {
    padding: 12px 16px;
    vertical-align: middle;
}

/* Nom + avatar */
.ens-name {
    display: flex;
    align-items: center;
    gap: 10px;
}
.ens-avatar {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: #ede9fe;
    color: #7c3aed;
    font-size: 0.75rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}
.ens-fullname {
    font-weight: 600;
    color: #1e293b;
}
.ens-phone {
    font-size: 0.75rem;
    color: #94a3b8;
    margin-top: 1px;
}

.ens-email {
    color: #7c3aed;
    text-decoration: none;
    font-size: 0.85rem;
}
.ens-email:hover { text-decoration: underline; }

.ens-badge {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 20px;
    font-size: 0.72rem;
    font-weight: 600;
    white-space: nowrap;
}

.ens-heures {
    font-weight: 600;
    color: #374151;
}

/* Cellule fusionnée statut + service hTD */
.ens-statut-htd {
    display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
}
.ens-heures-badge {
    font-size: 11px; font-weight: 700;
    background: #ede9fe; color: #5b21b6;
    padding: 2px 8px; border-radius: 10px;
    white-space: nowrap;
}

.ens-etat {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 20px;
    font-size: 0.72rem;
    font-weight: 600;
}
.ens-etat-actif   { background: #dcfce7; color: #15803d; }
.ens-etat-inactif { background: #f1f5f9; color: #64748b; }

.ens-empty-cell { color: #cbd5e1; }

.ens-col-heures  { text-align: center; }
.ens-col-etat    { text-align: center; }
.ens-col-actions { text-align: right; width: 80px; }

.ens-action-btn {
    background: none;
    border: none;
    width: 30px;
    height: 30px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.8rem;
    transition: background 0.1s, color 0.1s;
}
.ens-action-edit  { color: #64748b; }
.ens-action-edit:hover  { background: #ede9fe; color: #7c3aed; }
.ens-action-delete { color: #64748b; }
.ens-action-delete:hover { background: #fee2e2; color: #dc2626; }

.ens-count {
    padding: 10px 16px;
    font-size: 0.75rem;
    color: #94a3b8;
    border-top: 1px solid #f1f5f9;
}

/* ── États vides / loading ── */
.ens-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 60px 0;
    color: #94a3b8;
}
.ens-spinner { font-size: 2rem; }

.ens-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 60px 0;
    color: #94a3b8;
}
.ens-empty > i {
    font-size: 2.5rem;
    opacity: 0.3;
}
.ens-empty > p { margin: 0; font-size: 0.9rem; }

.ens-alert {
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 0.875rem;
    margin-bottom: 16px;
}
.ens-alert-error { background: #fee2e2; color: #dc2626; }

/* ── Modale ── */
.ens-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.ens-modal {
    background: white;
    border-radius: 14px;
    width: 100%;
    max-width: 560px;
    box-shadow: 0 20px 60px rgba(0,0,0,0.2);
    overflow: hidden;
}
.ens-modal-sm { max-width: 400px; }

.ens-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid #f1f5f9;
}
.ens-modal-header h3 {
    margin: 0;
    font-size: 1rem;
    font-weight: 700;
    color: #1e293b;
}
.ens-modal-close {
    background: none;
    border: none;
    color: #94a3b8;
    font-size: 1.1rem;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 6px;
}
.ens-modal-close:hover { background: #f1f5f9; color: #374151; }

.ens-modal-body {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.ens-form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
}
.ens-form-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
}
.ens-form-group label {
    font-size: 0.8rem;
    font-weight: 600;
    color: #374151;
}
.ens-label-hint {
    font-weight: 400;
    color: #94a3b8;
    margin-left: 6px;
}
.ens-form-group input,
.ens-form-group select {
    padding: 8px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 0.875rem;
    outline: none;
    transition: border-color 0.15s;
}
.ens-form-group input:focus,
.ens-form-group select:focus {
    border-color: #a78bfa;
    box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.1);
}

.ens-service-info {
    background: #f0fdf4;
    border: 1px solid #bbf7d0;
    color: #15803d;
    padding: 10px 14px;
    border-radius: 8px;
    font-size: 0.82rem;
    display: flex;
    align-items: center;
    gap: 8px;
}

.ens-form-check label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.875rem;
    color: #374151;
    cursor: pointer;
}

.ens-modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding-top: 4px;
}

.ens-btn {
    padding: 8px 18px;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    border: none;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: opacity 0.15s;
}
.ens-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.ens-btn-primary   { background: #7c3aed; color: white; }
.ens-btn-primary:hover:not(:disabled)  { background: #6d28d9; }
.ens-btn-secondary { background: #f1f5f9; color: #374151; }
.ens-btn-secondary:hover { background: #e2e8f0; }
.ens-btn-danger    { background: #dc2626; color: white; }
.ens-btn-danger:hover { background: #b91c1c; }

.ens-confirm-hint {
    font-size: 0.82rem;
    color: #64748b;
    margin: 4px 0 0;
}

/* ── Onglets topbar ── */
.ens-topbar-tabs { display: flex; gap: 4px; }
.ens-topbar-tab {
    background: rgba(255,255,255,0.15); border: none; color: rgba(255,255,255,0.85);
    padding: 6px 14px; border-radius: 6px; font-size: 13px; font-weight: 500;
    cursor: pointer; display: flex; align-items: center; gap: 6px; transition: all 0.15s;
}
.ens-topbar-tab:hover  { background: rgba(255,255,255,0.25); color: #fff; }
.ens-topbar-tab.active { background: rgba(255,255,255,0.95); color: #7c3aed; font-weight: 700; }

/* ── Actions topbar ── */
.ens-topbar-actions { display: flex; gap: 8px; align-items: center; }

/* ── Bouton Importer ── */
.ens-btn-import {
    background: rgba(255,255,255,0.15); border: 1px solid rgba(255,255,255,0.3);
    color: rgba(255,255,255,0.9); padding: 7px 14px; border-radius: 8px;
    font-size: 13px; font-weight: 500; cursor: pointer; display: flex; align-items: center; gap: 6px;
}
.ens-btn-import:hover { background: rgba(255,255,255,0.25); }

/* ── Form group textarea (ModalRef) ── */
.ens-form-group textarea {
    border: 1px solid #e2e8f0; border-radius: 8px; padding: 8px 12px; font-size: 13px;
    outline: none; transition: border-color 0.15s; resize: vertical;
}
.ens-form-group textarea:focus {
    border-color: #a78bfa;
    box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.1);
}

/* ── « Mon espace » → « Mes visites de stage » (lot 3.5c-4, maquette #tab-visites) ───────────────────── */
.ens-viewsw { display: flex; background: rgba(255,255,255,.15); border-radius: 8px; padding: 3px; gap: 2px; }
.ens-viewsw button { border: none; background: transparent; color: rgba(255,255,255,.85); font-size: 12px; font-weight: 600;
    padding: 6px 12px; border-radius: 6px; cursor: pointer; font-family: inherit; display: flex; align-items: center; gap: 6px; }
.ens-viewsw button.active { background: #fff; color: #6d28d9; }
.ens-mv-info { display: flex; gap: 10px; align-items: flex-start; background: #f5f3ff; border: 1px solid #ddd6fe; color: #4c1d95;
    border-radius: 8px; padding: 10px 14px; font-size: 12px; margin-bottom: 14px; line-height: 1.5; }
.ens-mv-info > i { margin-top: 2px; flex-shrink: 0; }
.ens-mv .ens-stat-label i { margin-right: 4px; }
.ens-mv-entete { display: flex; justify-content: space-between; align-items: center; gap: 10px; flex-wrap: wrap;
    padding: 10px 14px; border-bottom: 1px solid #e2e8f0; font-weight: 600; font-size: 13px; }
.ens-mv-sous { font-size: 10px; color: #64748b; font-weight: 400; margin-top: 2px; }
.ens-mv-ligne { cursor: pointer; }
.ens-mv-ligne:hover td { background: #faf5ff; }
.ens-mv-badge { display: inline-flex; align-items: center; gap: 4px; font-size: 11px; font-weight: 600; border-radius: 12px; padding: 2px 8px; white-space: nowrap; }
.ens-mv-badge.ok { background: #dcfce7; color: #15803d; }
.ens-mv-badge.plan { background: #fef3c7; color: #b45309; }
.ens-mv-badge.attente { background: #f1f5f9; color: #475569; }
.ens-mv-badge.formation { background: #ede9fe; color: #6d28d9; }
.ens-mv-action.voir { color: #6d28d9; border-color: #6d28d9; background: #f5f3ff; }
.ens-mv-action.saisir { color: #d97706; border-color: #fde68a; background: #fef9c3; }
.ens-mv .stg-barre { display: flex; gap: 2px; align-items: center; }
.ens-mv .stg-barre-compteur { font-size: 10px; color: #64748b; margin-left: 4px; }
.ens-mv .stg-barre-compteur.complet { color: #16a34a; font-weight: 700; }
.ens-mv-legende { display: flex; gap: 16px; flex-wrap: wrap; align-items: center; padding: 8px 14px; font-size: 11px; color: #64748b; border-top: 1px solid #e2e8f0; }
.ens-mv-legende span { display: flex; align-items: center; gap: 4px; }
.ens-mv-legende i { width: 12px; height: 8px; border-radius: 2px; display: inline-block; }
.ens-mv-cartes { display: none; }
.ens-mv-carte { background: #fff; border: 1px solid #e2e8f0; border-radius: 10px; padding: 12px; margin-bottom: 10px; cursor: pointer; }
.ens-mv-carte.a-faire { border-color: #fde68a; }
.ens-mv-carte-tete { display: flex; justify-content: space-between; gap: 8px; margin-bottom: 8px; }
.ens-mv-carte-nom { font-weight: 700; font-size: 14px; }
.ens-mv-carte-pied { display: flex; justify-content: space-between; align-items: center; margin: 8px 0; }
.ens-mv-carte-btn { width: 100%; justify-content: center; min-height: 44px; }
.ens-mv-fond { position: fixed; inset: 0; background: rgba(15, 23, 42, .4); z-index: 10001; /* au-dessus du bandeau « Année non active » (10000) */ display: flex; justify-content: flex-end; }
.ens-mv-volet { width: 640px; max-width: 100%; height: 100%; background: #f1f5f9; display: flex; flex-direction: column; box-shadow: -4px 0 20px rgba(0,0,0,.15); }
.ens-mv-volet-tete { display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 12px 16px; background: #fff; border-bottom: 1px solid #e2e8f0; }
.ens-mv-volet-tete h3 { font-size: 14px; margin: 0; color: #6d28d9; }
.ens-mv-volet-corps { flex: 1 1; overflow-y: auto; padding: 16px; }
@media (max-width: 760px) {
    .ens-mv-table { display: none; }
    .ens-mv-cartes { display: block; }
    .ens-viewsw button span { display: none; }
}

/* 2026-10-10 (v74) — les photos des enseignants : avatar de la liste, et le choix de la photo (maquette : .profile-avatar + .cam) */
.ens-avatar.av-photo { object-fit: cover; background: #ede9fe; }
.ens-photo-choix { display: flex; align-items: center; gap: 14px; padding: 10px 12px; margin-bottom: 12px; border: 1px solid #ede9fe; border-radius: 10px; background: #faf8ff; }
.ens-photo-cadre { position: relative; flex-shrink: 0; }
.ens-photo-av { width: 64px; height: 64px; border-radius: 50%; background: linear-gradient(135deg, #8b5cf6, #6d28d9); color: #fff; display: flex; align-items: center; justify-content: center; font-size: 24px; font-weight: 800; }
.ens-photo-av.av-photo { object-fit: cover; background: #ede9fe; }
.ens-photo-cam { position: absolute; right: -2px; bottom: -2px; width: 24px; height: 24px; border-radius: 50%; background: #fff; border: 1px solid #e2e8f0; color: #6d28d9; display: flex; align-items: center; justify-content: center; font-size: 10px; cursor: pointer; padding: 0; }
.ens-photo-cam:hover:not(:disabled) { background: #f5f3ff; }
.ens-photo-texte { min-width: 0; }
.ens-photo-titre { font-weight: 700; font-size: 13px; color: #1e293b; }
.ens-photo-aide { font-size: 11px; color: #64748b; margin-top: 2px; }
.ens-photo-retirer { margin-top: 6px; background: none; border: none; padding: 0; color: #b91c1c; font-size: 11px; cursor: pointer; }
.ens-photo-erreur { margin-top: 6px; color: #b91c1c; font-size: 11px; }
.ens-mv-maphoto { margin-bottom: 12px; }
`, "",{"version":3,"sources":["webpack://./src/components/Enseignants.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA,iDAAiD;AACjD;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,wDAAwD;AAC5D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,+EAA+E;AAC/E;IACI,iBAAiB;IACjB,oCAAoC;IACpC,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,4BAA4B;AAChC;AACA;IACI,oCAAoC;AACxC;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,SAAO;AACX;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,6CAA6C;AACjD;AACA;IACI,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAO;IACP,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,8BAA8B;IAC9B,sBAAsB;AAC1B;AACA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,eAAe;AACnB;AACA;IACI,qBAAqB;AACzB;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;AAC/B;AACA,iCAAiC,mBAAmB,EAAE;AACtD,4BAA4B,mBAAmB,EAAE;AACjD,oBAAoB,aAAa,EAAE;;AAEnC;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,kBAAkB;AACtB;AACA,mBAAmB,0BAA0B,EAAE;;AAE/C;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA,2CAA2C;AAC3C;IACI,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe;AACjE;AACA;IACI,eAAe,EAAE,gBAAgB;IACjC,mBAAmB,EAAE,cAAc;IACnC,gBAAgB,EAAE,mBAAmB;IACrC,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;AACA,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;;AAEzD,kBAAkB,cAAc,EAAE;;AAElC,mBAAmB,kBAAkB,EAAE;AACvC,mBAAmB,kBAAkB,EAAE;AACvC,mBAAmB,iBAAiB,EAAE,WAAW,EAAE;;AAEnD;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,uCAAuC;AAC3C;AACA,oBAAoB,cAAc,EAAE;AACpC,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,qBAAqB,cAAc,EAAE;AACrC,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;;AAEhE;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,6BAA6B;AACjC;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,cAAc;AAClB;AACA,eAAe,eAAe,EAAE;;AAEhC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,YAAY;AAChB;AACA,iBAAiB,SAAS,EAAE,iBAAiB,EAAE;;AAE/C;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;AACA,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;;AAExD,iBAAiB;AACjB;IACI,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,uCAAuC;IACvC,gBAAgB;AACpB;AACA,gBAAgB,gBAAgB,EAAE;;AAElC;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,gCAAgC;AACpC;AACA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;;AAE9D;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;AACA;;IAEI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;AAClC;AACA;;IAEI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;AAC7B;AACA,oBAAoB,YAAY,EAAE,mBAAmB,EAAE;AACvD,qBAAqB,mBAAmB,EAAE,YAAY,EAAE;AACxD,yCAAyC,mBAAmB,EAAE;AAC9D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,2BAA2B,mBAAmB,EAAE;AAChD,qBAAqB,mBAAmB,EAAE,YAAY,EAAE;AACxD,wBAAwB,mBAAmB,EAAE;;AAE7C;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA,yBAAyB;AACzB,mBAAmB,aAAa,EAAE,QAAQ,EAAE;AAC5C;IACI,kCAAkC,EAAE,YAAY,EAAE,6BAA6B;IAC/E,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB;IACxE,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,qBAAqB;AACxF;AACA,yBAAyB,kCAAkC,EAAE,WAAW,EAAE;AAC1E,yBAAyB,kCAAkC,EAAE,cAAc,EAAE,gBAAgB,EAAE;;AAE/F,yBAAyB;AACzB,sBAAsB,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE;;AAEpE,0BAA0B;AAC1B;IACI,kCAAkC,EAAE,uCAAuC;IAC3E,4BAA4B,EAAE,iBAAiB,EAAE,kBAAkB;IACnE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;AACpG;AACA,wBAAwB,kCAAkC,EAAE;;AAE5D,yCAAyC;AACzC;IACI,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe;IACjF,aAAa,EAAE,8BAA8B,EAAE,gBAAgB;AACnE;AACA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA,2GAA2G;AAC3G,cAAc,aAAa,EAAE,iCAAiC,EAAE,kBAAkB,EAAE,YAAY,EAAE,QAAQ,EAAE;AAC5G,qBAAqB,YAAY,EAAE,uBAAuB,EAAE,4BAA4B,EAAE,eAAe,EAAE,gBAAgB;IACvH,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE,oBAAoB,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAChI,4BAA4B,gBAAgB,EAAE,cAAc,EAAE;AAC9D,eAAe,aAAa,EAAE,SAAS,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,cAAc;IAC5H,kBAAkB,EAAE,kBAAkB,EAAE,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACpG,mBAAmB,eAAe,EAAE,cAAc,EAAE;AACpD,4BAA4B,iBAAiB,EAAE;AAC/C,iBAAiB,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe;IAC3G,kBAAkB,EAAE,gCAAgC,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC7F,eAAe,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACnF,gBAAgB,eAAe,EAAE;AACjC,yBAAyB,mBAAmB,EAAE;AAC9C,gBAAgB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AACpK,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,sBAAsB,cAAc,EAAE,qBAAqB,EAAE,mBAAmB,EAAE;AAClF,wBAAwB,cAAc,EAAE,qBAAqB,EAAE,mBAAmB,EAAE;AACpF,qBAAqB,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACnE,8BAA8B,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACjF,sCAAsC,cAAc,EAAE,gBAAgB,EAAE;AACxE,kBAAkB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,eAAe,EAAE,cAAc,EAAE,6BAA6B,EAAE;AACrK,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACrE,oBAAoB,WAAW,EAAE,WAAW,EAAE,kBAAkB,EAAE,qBAAqB,EAAE;AACzF,iBAAiB,aAAa,EAAE;AAChC,gBAAgB,gBAAgB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACvI,wBAAwB,qBAAqB,EAAE;AAC/C,qBAAqB,aAAa,EAAE,8BAA8B,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AAClG,oBAAoB,gBAAgB,EAAE,eAAe,EAAE;AACvD,qBAAqB,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,aAAa,EAAE;AACxG,oBAAoB,WAAW,EAAE,uBAAuB,EAAE,gBAAgB,EAAE;AAC5E,eAAe,eAAe,EAAE,QAAQ,EAAE,gCAAgC,EAAE,cAAc,EAAE,sDAAsD,EAAE,aAAa,EAAE,yBAAyB,EAAE;AAC9L,gBAAgB,YAAY,EAAE,eAAe,EAAE,YAAY,EAAE,mBAAmB,EAAE,aAAa,EAAE,sBAAsB,EAAE,uCAAuC,EAAE;AAClK,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,gCAAgC,EAAE;AAC5K,wBAAwB,eAAe,EAAE,SAAS,EAAE,cAAc,EAAE;AACpE,sBAAsB,SAAO,EAAE,gBAAgB,EAAE,aAAa,EAAE;AAChE;IACI,gBAAgB,aAAa,EAAE;IAC/B,iBAAiB,cAAc,EAAE;IACjC,0BAA0B,aAAa,EAAE;AAC7C;;AAEA,oIAAoI;AACpI,uBAAuB,iBAAiB,EAAE,mBAAmB,EAAE;AAC/D,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AAChL,mBAAmB,kBAAkB,EAAE,cAAc,EAAE;AACvD,gBAAgB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,qDAAqD,EAAE,WAAW,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACnO,yBAAyB,iBAAiB,EAAE,mBAAmB,EAAE;AACjE,iBAAiB,kBAAkB,EAAE,WAAW,EAAE,YAAY,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,eAAe,EAAE,UAAU,EAAE;AACvR,sCAAsC,mBAAmB,EAAE;AAC3D,mBAAmB,YAAY,EAAE;AACjC,mBAAmB,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE;AACtE,kBAAkB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACpE,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,YAAY,EAAE,UAAU,EAAE,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE;AACpI,oBAAoB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACtE,kBAAkB,mBAAmB,EAAE","sourcesContent":["/* ============================================================\n   Enseignants.css — Module Enseignants\n   Suit exactement le même pattern que AccueilDashboard\n   ============================================================ */\n\n.ens-page {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    background: #f8fafc;\n}\n\n/* ── Topbar (même règles qu'accueil-topbar) ── */\n.ens-topbar {\n    color: white;\n    padding: 12px 24px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n    position: sticky;\n    top: 0;\n    z-index: 50;\n    /* background défini via inline style (couleur module) */\n}\n\n.ens-topbar-left {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n}\n\n/* Icône dans un carré arrondi légèrement plus clair — même règle que sidebar */\n.ens-topbar-icon {\n    font-size: 1.4rem;\n    background: rgba(255, 255, 255, 0.2);\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 10px;\n    flex-shrink: 0;\n}\n\n.ens-topbar-title {\n    font-size: 1.05rem;\n    font-weight: 700;\n}\n\n.ens-topbar-sub {\n    font-size: 0.8rem;\n    opacity: 0.75;\n    margin-top: 2px;\n}\n\n.ens-btn-add {\n    background: rgba(255, 255, 255, 0.2);\n    border: 1px solid rgba(255, 255, 255, 0.4);\n    color: white;\n    border-radius: 8px;\n    padding: 8px 16px;\n    font-size: 0.875rem;\n    font-weight: 600;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    transition: background 0.15s;\n}\n.ens-btn-add:hover {\n    background: rgba(255, 255, 255, 0.3);\n}\n\n/* ── Corps de la page ── */\n.ens-content {\n    padding: 24px;\n    flex: 1;\n}\n\n/* ── Stat cards ── */\n.ens-stats {\n    display: flex;\n    gap: 12px;\n    flex-wrap: wrap;\n    margin-bottom: 20px;\n}\n\n.ens-stat-card {\n    background: white;\n    border-radius: 10px;\n    border-left: 4px solid #94a3b8;\n    padding: 12px 18px;\n    min-width: 130px;\n    cursor: pointer;\n    box-shadow: 0 1px 4px rgba(0,0,0,0.06);\n    transition: box-shadow 0.15s, transform 0.15s;\n}\n.ens-stat-card:hover {\n    box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n    transform: translateY(-1px);\n}\n\n.ens-stat-count {\n    font-size: 1.6rem;\n    font-weight: 800;\n    line-height: 1;\n}\n.ens-stat-label {\n    font-size: 0.75rem;\n    color: #64748b;\n    margin-top: 4px;\n}\n\n/* ── Toolbar filtres ── */\n.ens-toolbar {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 16px;\n    flex-wrap: wrap;\n}\n\n.ens-search-wrap {\n    position: relative;\n    flex: 1;\n    min-width: 220px;\n}\n.ens-search-wrap > i {\n    position: absolute;\n    left: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #94a3b8;\n    font-size: 0.85rem;\n}\n.ens-search {\n    width: 100%;\n    padding: 8px 36px 8px 34px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    font-size: 0.875rem;\n    outline: none;\n    background: white;\n    transition: border-color 0.15s;\n    box-sizing: border-box;\n}\n.ens-search:focus {\n    border-color: #a78bfa;\n    box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.1);\n}\n.ens-search-clear {\n    position: absolute;\n    right: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    color: #94a3b8;\n    cursor: pointer;\n    padding: 2px 4px;\n}\n\n.ens-filter-select {\n    padding: 8px 12px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    font-size: 0.875rem;\n    background: white;\n    color: #374151;\n    outline: none;\n    cursor: pointer;\n}\n.ens-filter-select:focus {\n    border-color: #a78bfa;\n}\n\n/* ── Tableau ── */\n.ens-table-wrap {\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 1px 4px rgba(0,0,0,0.06);\n    overflow: hidden;\n}\n\n.ens-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.875rem;\n}\n\n.ens-table thead th {\n    background: #f8fafc;\n    padding: 10px 16px;\n    text-align: left;\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: #64748b;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.ens-table tbody tr {\n    border-bottom: 1px solid #f1f5f9;\n    transition: background 0.1s;\n}\n.ens-table tbody tr:last-child { border-bottom: none; }\n.ens-table tbody tr:hover { background: #f8fafc; }\n.ens-row-inactive { opacity: 0.55; }\n\n.ens-table td {\n    padding: 12px 16px;\n    vertical-align: middle;\n}\n\n/* Nom + avatar */\n.ens-name {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n.ens-avatar {\n    width: 34px;\n    height: 34px;\n    border-radius: 50%;\n    background: #ede9fe;\n    color: #7c3aed;\n    font-size: 0.75rem;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n.ens-fullname {\n    font-weight: 600;\n    color: #1e293b;\n}\n.ens-phone {\n    font-size: 0.75rem;\n    color: #94a3b8;\n    margin-top: 1px;\n}\n\n.ens-email {\n    color: #7c3aed;\n    text-decoration: none;\n    font-size: 0.85rem;\n}\n.ens-email:hover { text-decoration: underline; }\n\n.ens-badge {\n    display: inline-block;\n    padding: 2px 10px;\n    border-radius: 20px;\n    font-size: 0.72rem;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.ens-heures {\n    font-weight: 600;\n    color: #374151;\n}\n\n/* Cellule fusionnée statut + service hTD */\n.ens-statut-htd {\n    display: flex; align-items: center; gap: 8px; flex-wrap: wrap;\n}\n.ens-heures-badge {\n    font-size: 11px; font-weight: 700;\n    background: #ede9fe; color: #5b21b6;\n    padding: 2px 8px; border-radius: 10px;\n    white-space: nowrap;\n}\n\n.ens-etat {\n    display: inline-block;\n    padding: 2px 10px;\n    border-radius: 20px;\n    font-size: 0.72rem;\n    font-weight: 600;\n}\n.ens-etat-actif   { background: #dcfce7; color: #15803d; }\n.ens-etat-inactif { background: #f1f5f9; color: #64748b; }\n\n.ens-empty-cell { color: #cbd5e1; }\n\n.ens-col-heures  { text-align: center; }\n.ens-col-etat    { text-align: center; }\n.ens-col-actions { text-align: right; width: 80px; }\n\n.ens-action-btn {\n    background: none;\n    border: none;\n    width: 30px;\n    height: 30px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 0.8rem;\n    transition: background 0.1s, color 0.1s;\n}\n.ens-action-edit  { color: #64748b; }\n.ens-action-edit:hover  { background: #ede9fe; color: #7c3aed; }\n.ens-action-delete { color: #64748b; }\n.ens-action-delete:hover { background: #fee2e2; color: #dc2626; }\n\n.ens-count {\n    padding: 10px 16px;\n    font-size: 0.75rem;\n    color: #94a3b8;\n    border-top: 1px solid #f1f5f9;\n}\n\n/* ── États vides / loading ── */\n.ens-center {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    padding: 60px 0;\n    color: #94a3b8;\n}\n.ens-spinner { font-size: 2rem; }\n\n.ens-empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    padding: 60px 0;\n    color: #94a3b8;\n}\n.ens-empty > i {\n    font-size: 2.5rem;\n    opacity: 0.3;\n}\n.ens-empty > p { margin: 0; font-size: 0.9rem; }\n\n.ens-alert {\n    padding: 12px 16px;\n    border-radius: 8px;\n    font-size: 0.875rem;\n    margin-bottom: 16px;\n}\n.ens-alert-error { background: #fee2e2; color: #dc2626; }\n\n/* ── Modale ── */\n.ens-modal-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.4);\n    z-index: 1000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n}\n\n.ens-modal {\n    background: white;\n    border-radius: 14px;\n    width: 100%;\n    max-width: 560px;\n    box-shadow: 0 20px 60px rgba(0,0,0,0.2);\n    overflow: hidden;\n}\n.ens-modal-sm { max-width: 400px; }\n\n.ens-modal-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 20px;\n    border-bottom: 1px solid #f1f5f9;\n}\n.ens-modal-header h3 {\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 700;\n    color: #1e293b;\n}\n.ens-modal-close {\n    background: none;\n    border: none;\n    color: #94a3b8;\n    font-size: 1.1rem;\n    cursor: pointer;\n    padding: 4px 8px;\n    border-radius: 6px;\n}\n.ens-modal-close:hover { background: #f1f5f9; color: #374151; }\n\n.ens-modal-body {\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.ens-form-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 14px;\n}\n.ens-form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n.ens-form-group label {\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: #374151;\n}\n.ens-label-hint {\n    font-weight: 400;\n    color: #94a3b8;\n    margin-left: 6px;\n}\n.ens-form-group input,\n.ens-form-group select {\n    padding: 8px 12px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    font-size: 0.875rem;\n    outline: none;\n    transition: border-color 0.15s;\n}\n.ens-form-group input:focus,\n.ens-form-group select:focus {\n    border-color: #a78bfa;\n    box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.1);\n}\n\n.ens-service-info {\n    background: #f0fdf4;\n    border: 1px solid #bbf7d0;\n    color: #15803d;\n    padding: 10px 14px;\n    border-radius: 8px;\n    font-size: 0.82rem;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.ens-form-check label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 0.875rem;\n    color: #374151;\n    cursor: pointer;\n}\n\n.ens-modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    padding-top: 4px;\n}\n\n.ens-btn {\n    padding: 8px 18px;\n    border-radius: 8px;\n    font-size: 0.875rem;\n    font-weight: 600;\n    cursor: pointer;\n    border: none;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    transition: opacity 0.15s;\n}\n.ens-btn:disabled { opacity: 0.6; cursor: not-allowed; }\n.ens-btn-primary   { background: #7c3aed; color: white; }\n.ens-btn-primary:hover:not(:disabled)  { background: #6d28d9; }\n.ens-btn-secondary { background: #f1f5f9; color: #374151; }\n.ens-btn-secondary:hover { background: #e2e8f0; }\n.ens-btn-danger    { background: #dc2626; color: white; }\n.ens-btn-danger:hover { background: #b91c1c; }\n\n.ens-confirm-hint {\n    font-size: 0.82rem;\n    color: #64748b;\n    margin: 4px 0 0;\n}\n\n/* ── Onglets topbar ── */\n.ens-topbar-tabs { display: flex; gap: 4px; }\n.ens-topbar-tab {\n    background: rgba(255,255,255,0.15); border: none; color: rgba(255,255,255,0.85);\n    padding: 6px 14px; border-radius: 6px; font-size: 13px; font-weight: 500;\n    cursor: pointer; display: flex; align-items: center; gap: 6px; transition: all 0.15s;\n}\n.ens-topbar-tab:hover  { background: rgba(255,255,255,0.25); color: #fff; }\n.ens-topbar-tab.active { background: rgba(255,255,255,0.95); color: #7c3aed; font-weight: 700; }\n\n/* ── Actions topbar ── */\n.ens-topbar-actions { display: flex; gap: 8px; align-items: center; }\n\n/* ── Bouton Importer ── */\n.ens-btn-import {\n    background: rgba(255,255,255,0.15); border: 1px solid rgba(255,255,255,0.3);\n    color: rgba(255,255,255,0.9); padding: 7px 14px; border-radius: 8px;\n    font-size: 13px; font-weight: 500; cursor: pointer; display: flex; align-items: center; gap: 6px;\n}\n.ens-btn-import:hover { background: rgba(255,255,255,0.25); }\n\n/* ── Form group textarea (ModalRef) ── */\n.ens-form-group textarea {\n    border: 1px solid #e2e8f0; border-radius: 8px; padding: 8px 12px; font-size: 13px;\n    outline: none; transition: border-color 0.15s; resize: vertical;\n}\n.ens-form-group textarea:focus {\n    border-color: #a78bfa;\n    box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.1);\n}\n\n/* ── « Mon espace » → « Mes visites de stage » (lot 3.5c-4, maquette #tab-visites) ───────────────────── */\n.ens-viewsw { display: flex; background: rgba(255,255,255,.15); border-radius: 8px; padding: 3px; gap: 2px; }\n.ens-viewsw button { border: none; background: transparent; color: rgba(255,255,255,.85); font-size: 12px; font-weight: 600;\n    padding: 6px 12px; border-radius: 6px; cursor: pointer; font-family: inherit; display: flex; align-items: center; gap: 6px; }\n.ens-viewsw button.active { background: #fff; color: #6d28d9; }\n.ens-mv-info { display: flex; gap: 10px; align-items: flex-start; background: #f5f3ff; border: 1px solid #ddd6fe; color: #4c1d95;\n    border-radius: 8px; padding: 10px 14px; font-size: 12px; margin-bottom: 14px; line-height: 1.5; }\n.ens-mv-info > i { margin-top: 2px; flex-shrink: 0; }\n.ens-mv .ens-stat-label i { margin-right: 4px; }\n.ens-mv-entete { display: flex; justify-content: space-between; align-items: center; gap: 10px; flex-wrap: wrap;\n    padding: 10px 14px; border-bottom: 1px solid #e2e8f0; font-weight: 600; font-size: 13px; }\n.ens-mv-sous { font-size: 10px; color: #64748b; font-weight: 400; margin-top: 2px; }\n.ens-mv-ligne { cursor: pointer; }\n.ens-mv-ligne:hover td { background: #faf5ff; }\n.ens-mv-badge { display: inline-flex; align-items: center; gap: 4px; font-size: 11px; font-weight: 600; border-radius: 12px; padding: 2px 8px; white-space: nowrap; }\n.ens-mv-badge.ok { background: #dcfce7; color: #15803d; }\n.ens-mv-badge.plan { background: #fef3c7; color: #b45309; }\n.ens-mv-badge.attente { background: #f1f5f9; color: #475569; }\n.ens-mv-badge.formation { background: #ede9fe; color: #6d28d9; }\n.ens-mv-action.voir { color: #6d28d9; border-color: #6d28d9; background: #f5f3ff; }\n.ens-mv-action.saisir { color: #d97706; border-color: #fde68a; background: #fef9c3; }\n.ens-mv .stg-barre { display: flex; gap: 2px; align-items: center; }\n.ens-mv .stg-barre-compteur { font-size: 10px; color: #64748b; margin-left: 4px; }\n.ens-mv .stg-barre-compteur.complet { color: #16a34a; font-weight: 700; }\n.ens-mv-legende { display: flex; gap: 16px; flex-wrap: wrap; align-items: center; padding: 8px 14px; font-size: 11px; color: #64748b; border-top: 1px solid #e2e8f0; }\n.ens-mv-legende span { display: flex; align-items: center; gap: 4px; }\n.ens-mv-legende i { width: 12px; height: 8px; border-radius: 2px; display: inline-block; }\n.ens-mv-cartes { display: none; }\n.ens-mv-carte { background: #fff; border: 1px solid #e2e8f0; border-radius: 10px; padding: 12px; margin-bottom: 10px; cursor: pointer; }\n.ens-mv-carte.a-faire { border-color: #fde68a; }\n.ens-mv-carte-tete { display: flex; justify-content: space-between; gap: 8px; margin-bottom: 8px; }\n.ens-mv-carte-nom { font-weight: 700; font-size: 14px; }\n.ens-mv-carte-pied { display: flex; justify-content: space-between; align-items: center; margin: 8px 0; }\n.ens-mv-carte-btn { width: 100%; justify-content: center; min-height: 44px; }\n.ens-mv-fond { position: fixed; inset: 0; background: rgba(15, 23, 42, .4); z-index: 10001; /* au-dessus du bandeau « Année non active » (10000) */ display: flex; justify-content: flex-end; }\n.ens-mv-volet { width: 640px; max-width: 100%; height: 100%; background: #f1f5f9; display: flex; flex-direction: column; box-shadow: -4px 0 20px rgba(0,0,0,.15); }\n.ens-mv-volet-tete { display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 12px 16px; background: #fff; border-bottom: 1px solid #e2e8f0; }\n.ens-mv-volet-tete h3 { font-size: 14px; margin: 0; color: #6d28d9; }\n.ens-mv-volet-corps { flex: 1; overflow-y: auto; padding: 16px; }\n@media (max-width: 760px) {\n    .ens-mv-table { display: none; }\n    .ens-mv-cartes { display: block; }\n    .ens-viewsw button span { display: none; }\n}\n\n/* 2026-10-10 (v74) — les photos des enseignants : avatar de la liste, et le choix de la photo (maquette : .profile-avatar + .cam) */\n.ens-avatar.av-photo { object-fit: cover; background: #ede9fe; }\n.ens-photo-choix { display: flex; align-items: center; gap: 14px; padding: 10px 12px; margin-bottom: 12px; border: 1px solid #ede9fe; border-radius: 10px; background: #faf8ff; }\n.ens-photo-cadre { position: relative; flex-shrink: 0; }\n.ens-photo-av { width: 64px; height: 64px; border-radius: 50%; background: linear-gradient(135deg, #8b5cf6, #6d28d9); color: #fff; display: flex; align-items: center; justify-content: center; font-size: 24px; font-weight: 800; }\n.ens-photo-av.av-photo { object-fit: cover; background: #ede9fe; }\n.ens-photo-cam { position: absolute; right: -2px; bottom: -2px; width: 24px; height: 24px; border-radius: 50%; background: #fff; border: 1px solid #e2e8f0; color: #6d28d9; display: flex; align-items: center; justify-content: center; font-size: 10px; cursor: pointer; padding: 0; }\n.ens-photo-cam:hover:not(:disabled) { background: #f5f3ff; }\n.ens-photo-texte { min-width: 0; }\n.ens-photo-titre { font-weight: 700; font-size: 13px; color: #1e293b; }\n.ens-photo-aide { font-size: 11px; color: #64748b; margin-top: 2px; }\n.ens-photo-retirer { margin-top: 6px; background: none; border: none; padding: 0; color: #b91c1c; font-size: 11px; cursor: pointer; }\n.ens-photo-erreur { margin-top: 6px; color: #b91c1c; font-size: 11px; }\n.ens-mv-maphoto { margin-bottom: 12px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
